import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import { Paper, Typography } from "@mui/material";

import Logo from "../../vendor/tiehoitokunta_logo_transparent.png";
import SupportFormComponent from "../../components/auth/SupportForm";

const Wrapper = styled(Paper)`
  max-width: 540px;
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

/**
 * Public support page.
 *
 * `/contact` cannot serve this audience: it is behind AuthGuard and submits by
 * creating a conversation, which needs two real users. A visitor stuck partway
 * through registration has neither an account nor an association.
 */
function Support() {
  return (
    <React.Fragment>
      <img
        src={Logo}
        alt="tiehoitokunta_logo"
        style={{ width: "150px", height: "150px" }}
      />
      <Wrapper>
        <Helmet title="Ota yhteyttä" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Ota yhteyttä
        </Typography>
        <Typography component="h2" variant="body1" align="center">
          Kerro mikä meni pieleen, niin autamme sinut eteenpäin.
        </Typography>

        <SupportFormComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default Support;
